import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import SiteMaintenance from 'components/SiteMaintenance';

interface MaintenanceWrapperProps {
  children: React.ReactNode;
}

const MaintenanceWrapper: React.FC<MaintenanceWrapperProps> = ({ children }) => {
  const flags = useFlags();
  const adsUnderMaintenanceEnabled = flags.adsUnderMaintenanceEnabled;

  // If maintenance mode is enabled, show the maintenance page
  if (adsUnderMaintenanceEnabled) {
    return <SiteMaintenance />;
  }

  // Otherwise, render the normal app content
  return <>{children}</>;
};

export default MaintenanceWrapper;
